import { jsx } from "react/jsx-runtime";
import { Button, Text } from "pcln-design-system";
import "react";
import analytics from "../analytics/analytics.js";
const handleChooseHotelRoomButtonClick = ({ hotelId, args, detailURL, clickedOnMap = 'N' })=>(event)=>{
        event.stopPropagation?.();
        event.preventDefault?.();
        analytics.log({
            label: 'HotelSearchResult',
            hotelId: hotelId,
            message: 'HOTEL_DETAIL_LINK_CLICKED',
            clickedOnMap,
            ...args
        });
        window.open(detailURL, '_blank');
    };
const ChooseHotelRoomButton = (props)=>{
    const { buttonProps, buttonCopy, detailURL, hotelId, args } = props;
    return /*#__PURE__*/ jsx(Button, {
        ...buttonProps,
        onClick: handleChooseHotelRoomButtonClick({
            hotelId,
            args,
            detailURL
        }),
        children: /*#__PURE__*/ jsx(Text, {
            bold: true,
            fontSize: 0,
            children: buttonCopy
        })
    });
};
ChooseHotelRoomButton.defaultProps = {
    buttonCopy: 'Choose Room',
    buttonProps: {},
    detailURL: '',
    hotelId: '',
    args: {}
};
export { ChooseHotelRoomButton, handleChooseHotelRoomButtonClick };
